import actions from '../../actionTypes';

export default category => {
  return {
    type: actions.EDIT_CATEGORY,
    category
  };
};



// WEBPACK FOOTER //
// ./src/reducers/categories/actions/editCategory.js